import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { CustomPageType } from '../../extViewmodels/sdk/models/CustomPageStyle';
import { useApiClient } from '../contexts/apiClient';

export const useCustomPageStyleByShortCode = (
	shortCode: string,
	type: CustomPageType
): UseQueryResult<string, Error> => {
	const { baseUrl } = useApiClient();

	return useQuery({
		queryKey: ['EventsCustomPageStyle', shortCode, type],
		queryFn: async () => {
			const response = await fetch(
				`${baseUrl}/public/events/${encodeURIComponent(shortCode)}/custom-page-style/${type}`
			);
			if (!response.ok) {
				if (response.status === 404) {
					return ''; // No custom styling
				}
				throw new Error(`Failed to fetch custom page style: ${response.statusText}`);
			}
			return response.text();
		},
		enabled: !!shortCode,
		staleTime: 300_000, // 5 minutes (styling changes infrequently)
		retry: false, // Disable retries — 404s are handled gracefully above
	});
};
